module.exports = __webpack_public_path__ + "media/honey-icons/icon-delete-26b6605e.svg";